import type { User } from '@halo/chat-sdk-react';
import SelfActions from './selfActions';
import ReceiverActions from './receiverActions';

interface FooterActionsProps {
  user: User;
  isMe: boolean;
}

const FooterActions = ({ user, isMe }: FooterActionsProps) => {
  return <>{isMe ? <SelfActions user={user} /> : <ReceiverActions user={user} />}</>;
};

const MemoizedFooterActions = memo(FooterActions);

export { MemoizedFooterActions as FooterActions };
